import { render } from "./SpacerPanel.vue?vue&type=template&id=3971a1aa&scoped=true"
import script from "./SpacerPanel.vue?vue&type=script&lang=js"
export * from "./SpacerPanel.vue?vue&type=script&lang=js"

import "./SpacerPanel.vue?vue&type=style&index=0&id=3971a1aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3971a1aa"]])

export default __exports__